import React, { Component } from "react";
import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Document, Page } from "react-pdf";
import attachmentsRequestHandler from "../../../api/attachmentsRemote";
import { isImg, isDoc } from "../../../utils/attachment";
import unrecognizedDocsStyles from "./ManageUnrecognizedDoc.module.css";
import { headers } from "../../../api/headers";
import UnrecognizedDocs from "../../../models/AutoDocRecognitionResponse";

const materialStyles = (theme: Theme) =>
  createStyles({
    close: {
      position: 'absolute',
      right: '1%',
      zIndex: 12,
      top: '3%'
    },
    left_arrow: {
      position: 'fixed',
      top: '50%',
      left: '0',
      zIndex: 12,
    },
    right_arrow: {
      position: 'fixed',
      top: '50%',
      right: '1%',
      zIndex: 12
    }
  });

interface ViewDocumentsProps {
  classes: any;
  docData: Array<UnrecognizedDocs>;
};

interface ViewDocumentsState {
  numPages: any;
};

class ViewDocuments extends Component<ViewDocumentsProps, ViewDocumentsState> {
  state: ViewDocumentsState = {
    numPages: {}
  };

  openLink = (link: string): void => {
    window.open(link);
  }

  onDocumentLoadSuccess = (num: any, index: number): void => {
    const numPages = this.state.numPages;
    numPages[`pdf_${index}`] = num._pdfInfo.numPages;
    this.setState({ numPages });
  }

  render() {
    return (
      <div>
        {this.props.docData.map((item: any, i: number) => {
          const itemLink: string = attachmentsRequestHandler.constructUnrecognizedAttachmentUrl(
            item.attachment_key
          );
          const fileName: string = item.attachment_key.split("/").pop();
          return (
            <div key={i} className={ unrecognizedDocsStyles.canvasDoc }>

              { isImg(fileName) && (
                <img
                  src={ itemLink }
                  alt={ fileName }
                  className={ unrecognizedDocsStyles.image }
                />
              )}
              { isDoc(fileName) && (
                <Document
                  file={ itemLink }
                  onItemClick={ () => {
                    this.openLink(itemLink);
                  } }
                  options={ {
                    httpHeaders: headers,
                    withCredentials: true
                  } }
                  onLoadSuccess={ (page) => this.onDocumentLoadSuccess(page, i) }
                > {
                    Array.from(
                      new Array(this.state.numPages[`pdf_${i}`]),
                      (el, index) => (
                        <Page
                          key={ `page_${index + 1}` }
                          pageNumber={ index + 1 }
                        />
                      )
                    )
                  }
                </Document>
              )}
            </div>
          );
        })}
      </div>
    );
  }

}

export default withStyles(materialStyles)(ViewDocuments);
